
$(document).ready(function () {
  jQuery('main').insertAfter('header');
  jQuery('.mobile-menu-wrapper').insertAfter('.site-footer');
  countDownIni('.flip-countdown,.js-flip-countdown');
    /********* On scroll heder Sticky *********/
    function initHeaderSticky() {
        if (jQuery(document).height() > jQuery(window).height()) {
            if (jQuery('.site-header .main-navigationbar').hasClass("sticky-header")) {
                if (jQuery(this).scrollTop() > 400) {
                    jQuery('.site-header .main-navigationbar').addClass("fixed");

                } else {
                    jQuery('.site-header .main-navigationbar').removeClass("fixed");
                }
            } else {
                jQuery('.site-header .main-navigationbar').removeClass("fixed");
            }
        }
    }
    $(document).ready(function () {
        initHeaderSticky()
    });
    $(window).resize(function () {
        initHeaderSticky()
    });
    $(window).scroll(function () {
        initHeaderSticky()
    });
    $(document).ready(function () {

        var prevScrollpos = window.pageYOffset;
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                document.getElementById("header-sticky").style.top = "0";
            } else {
                document.getElementById("header-sticky").style.top = "-200px";
            }
            prevScrollpos = currentScrollPos;
        }
    });

    /*  menu hover */
    $(".menu-lnk.has-item").hover(function () {
        $(this).toggleClass("menu_active");
        $(this).find(".menu-dropdown").toggleClass("open_menu");
        $("body").toggleClass("no_scroll");
    });

          // currency-nice-select
$('body').on('click', '.country-name .nice-select', function (e) {
  e.stopPropagation(); // Stop the event from propagating to the body
  $(this).toggleClass('open');
});
$('body').on('click', function (e) {
  $('.country-name .nice-select').removeClass('open');
});

   /********* mobile stickybar ********/
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            $(".mobile-stickybar").addClass('show');
        } else {
            $(".mobile-stickybar").removeClass('show');
        }
    });

// currency
function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
  currencyItem.addEventListener('click', function () {
    // Trigger change event on the associated select element
    var selectElement = this.closest('.country-name').querySelector('select');
    if (selectElement) {
      // Set the selected option based on the data-currency attribute of the clicked li
      selectElement.value = this.dataset.currency;
      
      // Trigger change event
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);

      // Submit the form
      currencyFormSubmit({ target: selectElement });
    }
  });
});
    /********* Mobile Menu ********/
    $('.mobile-menu-button').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no_scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
    });
    $('body').on('click', '.menu-close-icon svg', function (e) {
        e.preventDefault();
        $('body').removeClass('no_scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
    });

/********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no_scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no_scroll');
      $('.overlay').removeClass('active');
    });    

     // ============= cart popup============
 if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
      $('body').addClass('no_scroll cartopen');
      $('.overlay').addClass('cart-overlay');
  });
    
  }

  $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart-overlay');
    $('body').removeClass('no_scroll cartopen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

    /*********coupon popup ********/
      $(document).on('click', '.coupan-icon', function () {
        $(".coupon-popup").toggleClass("active");
      });
      $(document).on('click', '.gift-icon', function () {
        $(".coupon-popup").removeClass("active");
      });
      $(document).on('click', '.close-coupon', function () {
        $(".coupon-popup").removeClass("active");
      });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });
  
/*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").addClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });

    /*********  Size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no_scroll");
  });
  $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no_scroll");
  });
  $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no_scroll");
  });
  $('body').on('click', '.overlay, .close-btn', function (e) {
  e.preventDefault();
  $('body').removeClass('no_scroll search_open');
  $(".search-popup").removeClass("active");
  $('.overlay').removeClass('active');
});
    /******* Subscribe popup Js *******/

  if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no_scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no_scroll');
    });   
  
    /*********  ask qustion Popup  ********/
    $(".pro-features li a.ask-qus").click(function () {
        $(".ask-qus-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
    });
    $(".close-search").click(function () {
        $(".ask-qus-popup").removeClass("active");
        $("body").removeClass("no_scroll");
    });

    /*********  delivery-popup ********/
    $(".pro-features li a.del-qus").click(function () {
        $(".delivery-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
    });
    $(".close-search").click(function () {
        $(".delivery-popup").removeClass("active");
        $("body").removeClass("no_scroll");
    });

    /*********  Header Search Popup  ********/
    $(".search-header a").click(function () {
        $(".search-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
        $('.overlay').addClass('active');
        $('body').addClass('search-overlay');
    });
    $(".close-search").click(function () {
        $(".search-popup").removeClass("active");
        $("body").removeClass("no_scroll"); +
            $('.overlay').removeClass('active');
        $('body').removeClass('search-overlay');
    });

    /******* Cookie Js *******/
    $('.cookie-accept-btn').click(function () {
        $('.cookie-popup').slideUp();
    });

    /*********  Multi-level accordion nav  ********/
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });

    /****  TAB Js ****/
    $("ul.tabs li").click(function () {
        var $this = $(this);
        var $theTab = $(this).attr("data-tab");
        if ($this.hasClass("active")) {
        } else {
            $this
                .closest(".tabs-wrapper")
                .find("ul.tabs li, .tabs-container .tab-content")
                .removeClass("active");
            $(
                '.tabs-container .tab-content[id="' +
                $theTab +
                '"], ul.tabs li[data-tab="' +
                $theTab +
                "]"
            ).addClass("active");
        }
        $(this).addClass("active");
    });

    /** footer acnav **/
    $('.acnav-label1').click(function (event) {
        event.preventDefault();
        if (jQuery(window).width() < 768) {
            var label = $(this);
            var parent = label.parent('.has-children1');
            var list = label.siblings('.acnav-list1');
            if (parent.hasClass('is-open')) {
                list.slideUp('fast');
                parent.removeClass('is-open');
            }
            else {
                list.slideDown('fast');
                parent.addClass('is-open');
            }
        }
    });

    /*** home banner slider **/
    var swiper = new Swiper(".home-banner-slider", {
        speed: 800,
        loop: true,
        effect: 'fade',
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            }
        },
    });

    /*** categories slider **/
    var swiper = new Swiper(".category-slider", {
        slidesPerView: 6,
        spaceBetween: 15,
        loop: true,
        speed: 800,
        navigation: {
            nextEl: ".category-arrow.swiper-button-next",
            prevEl: ".category-arrow.swiper-button-prev",
        },
        breakpoints: {
            1200: {
                slidesPerView: 6,
            },
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            475: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** product slider **/
    var swiper = new Swiper(".product-slider", {
        spaceBetween: 15,
        loop: false,
        slidesPerColumn: 2,
        slidesPerView: 4,
        speed: 800,
        grid: {
            rows: 2,
        },
        navigation: {
            nextEl: ".product-arrow.swiper-button-next",
            prevEl: ".product-arrow.swiper-button-prev",
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
                grid: {
                    rows: 2,
                },
            },
            1024: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            768: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            575: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                },
            },
            320: {
                slidesPerView: 1,
                grid: {
                    rows: 2,
                },
            },
            0: {
                slidesPerView: 1,
                grid: {
                    rows: 2,
                },
            },
        },
    });

    /*** column-left-slider slider **/
    var swiper = new Swiper(".column-left-slider", {
        slidesPerView: 6,
        spaceBetween: 15,
        loop: false,
        speed: 800,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** column-right-slider slider **/
    var swiper = new Swiper(".column-right-slider", {
        spaceBetween: 15,
        loop: false,
        speed: 800,
        slidesPerView: 4,
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 1,
            },
            575: {
                slidesPerView: 2,
            },
            320: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /*** testimonial slider **/
    var swiper = new Swiper(".testimonial-slider", {
        slidesPerView: 6,
        spaceBetween: 15,
        loop: true,
        speed: 800,
        navigation: {
            nextEl: ".testimonial-arrow.swiper-button-next",
            prevEl: ".testimonial-arrow.swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });

    /*** home blog slider **/
    var swiper = new Swiper(".home-blog-slider", {
        slidesPerView: 6,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        navigation: {
            nextEl: ".blog-arrow.swiper-button-next",
            prevEl: ".blog-arrow.swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            475: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** partner logo slider **/
    var swiper = new Swiper(".partner-logo-slider", {
        slidesPerView: 7,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        autoplay: true,
              navigation: {
            nextEl: ".brand-arrow.swiper-button-next",
            prevEl: ".brand-arrow.swiper-button-prev",
        },
        breakpoints: {
            1200: {
                slidesPerView: 6,
            },
            992: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 4,
            },
            576: {
                slidesPerView: 3,
            },
            476: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** about product slider **/
    var swiper = new Swiper(".about-product-sec .about-product-slider", {
        loop: true,
        slidesPerView: 6,
        autoplay: true,
        centeredSlides: true,
        speed: 800,
        breakpoints: {
            1200: {
                slidesPerView: 5,
                centeredSlides: false,
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 15,
            },
            575: {
                slidesPerView: 2,
                centeredSlides: false,
                spaceBetween: 15,
            },
            0: {
                slidesPerView: 1,
                centeredSlides: false,
                spaceBetween: 15,
            },
        },
    });

    /** bottom-thumbslider **/
        var galleryThumbs = new Swiper(".gallery-thumbs", {
            centeredSlides: false,
            centeredSlidesBounds: true,
            slidesPerView: 4,
            spaceBetween: 10,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: "horizontal",
            breakpoints: {
                320: {
                    direction: 'horizontal',
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
            },
        });
    var galleryMain = new Swiper(".gallery-main", {
        watchOverflow: true,
        speed: 600, // Increase the speed for a smooth transition
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        navigation: {
            nextEl: '.pdp-arrow.swiper-button-next',
            prevEl: '.pdp-arrow.swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });

    galleryMain.on('slideChangeTransitionStart', function () {
        galleryThumbs.slideTo(galleryMain.activeIndex);
    });

    galleryThumbs.on('transitionStart', function () {
        galleryMain.slideTo(galleryThumbs.activeIndex);
    });
  
    /** client logo slider **/
    var swiper = new Swiper(".about-team-slider", {
        slidesPerView: 4,
        loop: true,
        speed: 800,
        spaceBetween: 20,
        autoplay: true,
        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** About Page service slider **/
    var swiper = new Swiper(".about-service-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 800,
        autoplay: true,
        navigation: {
            nextEl: ".about-service-arrow.swiper-button-next",
            prevEl: ".about-service-arrow.swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** blog page slider **/
    var swiper = new Swiper(".elegant-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        speed: 800,
        navigation: {
            nextEl: ".elegant-arrow.swiper-button-next",
            prevEl: ".elegant-arrow.swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
        },
    });

    /** counter js **/
    $('.counting').each(function () {
        var $this = $(this),
            countTo = $this.attr('data-count');

        $({ countNum: $this.text() }).animate({
            countNum: countTo
        },

            {
                duration: 3000,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(this.countNum);
                }

            });
    });

// product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 1
      });
    });
  

 // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky
  
 // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-right-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#ffffff' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  }); 
     setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-sec').find("li.active").removeClass('active');
    $('.pdp-tab-sec').find("li[data-tab='pdp-tab-3']").addClass('active');
    $('.tab-content.active').removeClass('active');
    $(".tab-content[id='pdp-tab-3']").addClass('active'); 
    });
  }, 1000); 

   setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab').find('.review_tab').addClass('is-open');
    $('.review_tab.is-open').find('.acnav-list').css('display','block');  
    });
  }, 1000); 

    // notify me
            $('body').on('click','.notify-btn', function(e) {
                e.preventDefault();
                $('body').addClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').addClass('active');
              });
             $('body').on('click','.overlay,.notify-popup-close', function(e) {
                e.preventDefault();
               $('body').removeClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').removeClass('active');
              });
   var swiper = new Swiper(".related-sidebar-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 1,
      },
    },
  });

    /******* quick-view-popup Js *******/

  $(".quick-close-btn").click(function () {
    $(".quick-view-popup").removeClass("active");
    $("body").removeClass("no_scroll");
  });
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
    var swiper = new Swiper(".quickview-img-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 800,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".quickview-arrowswiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
    });    
    });
    $(".quick-view-popup").toggleClass("active");
    $("body").toggleClass("no_scroll");
  });
  
$('body').on('click', '.quickview_popup_data .radio-buttons .button', function() {
   var data_val = $(this).children('input:checked').val();
   $(this).parents('.color-variant-swatch').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .radio-buttons .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
/******* quick-view-popup end *******/

    /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view ");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').appendTo(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);

        var prod_labl = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_labl);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);

         var prod_btn2 = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-form').appendTo(prod_btn2);

        var prod_title = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').prependTo(prod_title);

        var timer_btn = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(timer_btn);
          
        var prod_rew = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrp').appendTo(prod_rew);

        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').prependTo(prod_rew);

        var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_btn);  
  
         var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
      });
    });

  

    //******** progress-wrap ************//
    function scrollIndicator() {
        const scrollTop = document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const windowHeight = document.documentElement.clientHeight;
        const maxScrollTop = scrollHeight - windowHeight;
        const scrollPointBottom = $('.scroll-line').outerHeight();
        const scrollPointPos = (scrollTop * scrollPointBottom) / maxScrollTop;

        if (scrollTop > 200) {
            $('.scroll-progress').addClass('visible');
        } else {
            $('.scroll-progress').removeClass('visible');
        }

        anime({
            targets: '.scroll-point',
            perspective: '500px',
            translateX: 0,
            translateY: scrollPointPos,
            translateZ: '0',
            easing: 'easeOutCirc'
        });
    }
    $(document).ready(function () {
        // Initial call on document ready
        scrollIndicator();

        // Attach scroll event listener
        $(document).scroll(function () {
            scrollIndicator();
        });
    });

  // load-more button scroll
if ($('.load-more_wrap').hasClass('load-more-btn')){
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val());
  var data_winurl = window.location.href.split('/collections');
  var final_data_url = data_winurl[1];
  var finalURL = "/collections" + final_data_url;
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      if (finalURL.includes('filter.')) {
        $('[data-next-link]').val(finalURL + "&page=" + next_coll);
       }else{
         $('[data-next-link]').val(finalURL + "?page=" + next_coll);
       }
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-grid-view, .product-list-view, .flex-slider').append($(responseHTML).find('.product-grid-view, .product-list-view, .flex-slider').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

      // start list
 // common list
        jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').appendTo(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
      
  

      // start grid
           jQuery('.product-grid-view > .grid__item').each(function() {
        
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);

        var prod_labl = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_labl);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);

         var prod_btn2 = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-form').appendTo(prod_btn2);

        var prod_title = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').prependTo(prod_title);

        var timer_btn = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(timer_btn);
          
        var prod_rew = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrp').appendTo(prod_rew);

        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').prependTo(prod_rew);

        var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_btn);  
  
         var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
      });
//       //end grid
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    
 //   $(".menu-lnk.has-item").hover(function () {
 //    $('body').toggleClass("no-scroll");
 // });
  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-list-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
}
// load-more button scroll end

// infinit scroll
if ($('.load-more_wrap').hasClass('infinite-scroll')){
var infinitelastLoadedUrl = "";
  // Function to load more products
  function infiniteloadMoreProducts(nextUrl, totalPages) {
    if (nextUrl === infinitelastLoadedUrl) {
          return; // Exit function if nextUrl is repeated
      }
     infinitelastLoadedUrl = nextUrl;
      var currentPage = parseInt($('[data-this-page]').val());
      var data_winurl = window.location.href.split('/collections');
      var final_data_url = data_winurl[1];
      var finalURL = "/collections" + final_data_url;
  
      // Disable load more button and show loader
      $('[loader]').removeClass('hide');
  
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;
  
      $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML) {
             if (finalURL.includes('filter.')) {
              $('[data-next-link]').val(finalURL + "&page=" + next_coll);
             }else{
               $('[data-next-link]').val(finalURL + "?page=" + next_coll);
             }
            $('[data-this-page]').val(current_page_new);
  
              // Append loaded products to the container
              $('.product-grid-view, .product-list-view, .flex-slider').append($(responseHTML).find('.product-grid-view, .product-list-view, .flex-slider').html());
  
              // Call any necessary initialization functions
              countDownIni('.flip-countdown,.js-flip-countdown');
             // start list
 // common list

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').appendTo(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
      
  

      // start grid
           jQuery('.product-grid-view > .grid__item').each(function() {
        
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);

        var prod_labl = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_labl);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);

         var prod_btn2 = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-form').appendTo(prod_btn2);

        var prod_title = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').prependTo(prod_title);

        var timer_btn = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(timer_btn);
          
        var prod_rew = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrp').appendTo(prod_rew);

        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').prependTo(prod_rew);

        var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_btn);  
  
         var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
      });
//       //end grid
          },
          complete: function() {
              if (current_page_new < totalPages) {
                  // Re-enable load more button and hide loader
                  $('[loader]').addClass('hide');
              } else {
                  // Hide load more button if there are no more pages
                  $('[loader]').removeClass('hide');
              }
          }
      });
  }
  
  // Scroll event listener for infinite scroll
  $.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }; 
  $(window).on('scroll load', function() {
  if ($('.load-more_wrap').isInViewport()) {
          var currentPage = parseInt($('[data-this-page]').val());
          var nextUrl = $('[data-next-link]').val();
          var totalPages = parseInt($('[data-all-pages]').val());
          if (currentPage >= totalPages) {
//             // Hide loader and exit function
            $('[loader]').addClass('hide');
        }else{
          infiniteloadMoreProducts(nextUrl, totalPages);
          $('[loader]').removeClass('hide');
        }
  }
  });
  
}

//end infinite
  
  function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }

    if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('div');
      newDiv.className = 'mobile-lag d-flex align-items-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.country-name, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
   $('.country-name, .languages').appendTo('.annoucebar-right');
    $('.mobile-lag').remove();
  }
    
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
});
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<div class="days"><span class="count count-days">%D</span><span class="counter-dtl">days</span></div>' + '<div class="hour"><span class="count count-hours">%H</span><span class="counter-dtl">hrs</span></div>' + '<div class="mins"><span class="count count-minites">%M</span><span class="counter-dtl">mins</span></div>' + ' <div class="secs"><span class="count count-seconds">%S</span><span class="counter-dtl">secs</span></div>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
 }